import React from 'react';
import styled from '@emotion/styled';

export const IconPlay = () => {
  return (
    <StyledIconPlaySpan className="icon-svg IconPlay">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <g className="a">
          <g transform="translate(4 2)">
            <path
              className="b"
              d="M15.213,7.606A7.607,7.607,0,1,1,7.607,0,7.606,7.606,0,0,1,15.213,7.606Z"
              transform="translate(0 0)"
            />
            <path className="c" d="M0,0,1.4,3,2.8,0Z" transform="translate(6.206 16.01)" />
          </g>
          <rect className="d" width="24" height="24" />
        </g>
      </svg>
    </StyledIconPlaySpan>
  );
};

const StyledIconPlaySpan = styled.span`
  & .a {
    opacity: 0.7;
  }

  & .b {
    fill: rgba(0, 0, 0, 0);
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }

  & .c {
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: 2px;
    fill: #8c8c91;
  }

  & .d {
    fill: none;
  }

  display: inline-block;
  vertical-align: sub;
`;
